import styled from 'styled-components';

export const CellContent = styled.div`
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
`;
